import React from "react";
import { useSelector } from "react-redux";
import { SUBSCRIPTION_MODULE_TYPE } from "../constants";

const stripHtml = value =>
  String(value || "")
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/\s+/g, " ")
    .trim();

const isBusinessPlan = plan =>
  parseInt(plan?.planType?.value) === SUBSCRIPTION_MODULE_TYPE.BUSINESSPLAN ||
  (
    parseInt(plan?.planType?.value) === SUBSCRIPTION_MODULE_TYPE.CUSTOM &&
    (plan?.activationplan === true || plan?.activationPlan === true)
  );

const BulletSection = ({ title, children }) => {
  if (!children) return null;

  return (
    <div className="recommended-plan-card-section">
      <span className="recommended-plan-card-dot" aria-hidden="true" />
      <div>
        <strong>{title}</strong>
        <p>{children}</p>
      </div>
    </div>
  );
};

export default function RecommendedPlanCard({
  recommendedPlan,
  style,
  useSelectedPlanDetails = false,
  variant,
}) {
  const { stripePlans } = useSelector(state => state.stripe);
  const { productPlanList, selectedPlanProduct } = useSelector(state => state.subscriptionPlanProducts);
  const firstBusinessPlan = productPlanList?.find(isBusinessPlan);

  const selectedBusinessPlan = useSelectedPlanDetails
    ? isBusinessPlan(selectedPlanProduct)
      ? selectedPlanProduct
      : isBusinessPlan(stripePlans)
        ? stripePlans
        : firstBusinessPlan || null
    : null;

  const planTitle =
    selectedBusinessPlan?.fullName ||
    recommendedPlan?.planName;

  const whoItsFor =
    recommendedPlan?.whoItsFor ||
    selectedBusinessPlan?.whoItsFor ||
    stripHtml(selectedBusinessPlan?.targetAudience);

  const whatsIncluded =
    recommendedPlan?.whatsIncluded ||
    selectedBusinessPlan?.whatsIncluded ||
    stripHtml(selectedBusinessPlan?.description || selectedBusinessPlan?.shortDescription);

  if (!planTitle && !whoItsFor && !whatsIncluded) {
    return null;
  }

  return (
    <section className={`recommended-plan-card ${variant === "summary" ? "summary" : ""}`} style={style}>
      <p>Recommended plan (AI suggested)</p>
      {planTitle && <h3>{planTitle}</h3>}
      <BulletSection title="Who it's for">{whoItsFor}</BulletSection>
      <BulletSection title="What's included">{whatsIncluded}</BulletSection>
      <div className="recommended-plan-card-disclaimer">
        <p>
          <strong>This suggestion is not final.</strong> It's based on the
          information you've entered so far. Once your business is set up,
          kimbocorp will review your actual business activity. If it turns out
          to be different from what's shown here, kimbocorp may reclassify your
          company to the correct plan and charge the difference in fees.
        </p>
      </div>
    </section>
  );
}
